(function () {
  var sidebar = document.getElementById('sidebar-menu');
  if (!sidebar) return;

  function collapsiblePanel() {
    return sidebar.querySelector('[slot="collapsible-panel"]');
  }

  sidebar.addEventListener('click', function (event) {
    var openCatBtn = event.target.closest('[data-eros-drawer-open-cat]');
    if (openCatBtn) {
      event.preventDefault();
      var index = openCatBtn.getAttribute('data-eros-drawer-open-cat');
      var panel = collapsiblePanel();
      if (panel && index) {
        panel.setAttribute('aria-activedescendant', 'eros-drawer-panel-cat-' + index);
      }
      return;
    }

    var backProductsBtn = event.target.closest('[data-eros-drawer-back-products]');
    if (backProductsBtn) {
      event.preventDefault();
      var panelBack = collapsiblePanel();
      if (panelBack) {
        panelBack.setAttribute('aria-activedescendant', 'eros-drawer-panel-products');
      }
    }
  });
})();
